import React, { useState, useEffect } from "react";
import columns from "../../../columns/PaymentGatway";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import { GetAllPaymentGatwaysApi, UpdatePaymentGatwayStatusApi, UpdategetwayApi } from "../../../api/request/settings/paymentGatway.js";
import { GetAllCountryApi } from "../../../api/request/common.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import { Switch, Form, Select } from "antd";
import toast from "react-hot-toast";
import Edit from '../../../assets/Edit.jsx';
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

export default function PaymentGatway() {

  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedPaymentGatway, setSelectedPaymentGatway] = useState(null);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [countries, setCountries] = useState([]);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [initialValues, setInitialValues] = useState({ countryId: null, });
  const [isEditPaymentLoading, setIsEditPaymentLoading] = useState(false);

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.countryName })));
      }
    } catch (error) { }
  }

  useEffect(() => {
    getContriens();
  }, []);

  const statusHandler = (value) => {
    setSelectedPaymentGatway(value);
    setIsStatusConfirmOpen(true);
  }

  const getPaymentGatways = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
      }
      const { data } = await GetAllPaymentGatwaysApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              status: <Switch onChange={() => statusHandler(item)} checkedChildren="Active" unCheckedChildren="Inactive" checked={item?.isActive} />,
              action: <button type="button" onClick={() => { setSelectedId(item?.paymentGatewayId); setIsOpenEditModal(true); }}><Edit /></button>
            }
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  }

  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);
      let params = {
        paymentGatewayId: selectedPaymentGatway?.paymentGatewayId,
        isActive: !selectedPaymentGatway?.isActive
      }
      const { data } = await UpdatePaymentGatwayStatusApi(params);
      if (data?.success) {
        getPaymentGatways();
        toast.success(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      setIsStatusConfirmLoading(false);
    }
  }

  useEffect(() => {
    if (!isOpenEditModal) {
      form?.resetFields();
    }
  }, [isOpenEditModal]);

  useEffect(() => {
    getPaymentGatways();
  }, [page, pageSize]);

  const handleEditSubmit = async (value) => {
    try {
      let apiParams = {
        paymentGatewayId: selectedId,
        CountryId: value?.countryId?.join(', ')
      };
      setIsEditPaymentLoading(true);
      const { data } = await UpdategetwayApi(apiParams);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsEditPaymentLoading(false);
        setIsOpenEditModal(false);
        getPaymentGatways();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsEditPaymentLoading(false);
    }
  };

  const filterOption = (input, option) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  }

  return (
    <div>
      <div>
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            page={page}
            pageSize={pageSize}
          />
        </div>
        <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </div>

      {/* Payment gatway status change confirmation modal */}
      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message='Are you sure to change the payment gatway status?'
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel='Changing status...'
      />

      {/* update modal */}
      <ModalComponent isOpen={isOpenEditModal} setIsOpen={setIsOpenEditModal} title="Update" width={500}>
        <Form className="w-full" autoComplete="off" form={form} initialValues={initialValues} onFinish={handleEditSubmit}>
          <div className="ant-multi-select-selector ant-select-selector-white">
            <p className="text-[#585F70] font-semibold mb-[2px]">Select Your Country</p>
            <Form.Item name="countryId" rules={[{ required: true, message: 'Please select a country.' }]}>
              <Select showSearch mode="multiple" filterOption={filterOption} options={countries} className="w-full mt-1" placeholder='Select a country' />
            </Form.Item>
          </div>
          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
              type="submit"
              lable="Update"
              isLoading={isEditPaymentLoading}
              loadingLable="Updating rules..."
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
